export default "__VITE_ASSET__BgpFyxBv__"